<template>
  <div class="step-2">
    <div v-if="authType === 'UNION_PAY_AUTH'">
      <a-form
        class="mod-form"
        layout="horizontal"
        labelAlign="left"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :colon="false"
        :form="form"
        @submit="onSubmit"
      >
        <a-form-item label="中文姓">
          <a-input
            size="large"
            placeholder="请输入姓"
            v-decorator="[
              'surname',
              {
                initialValue: userInfo.chiSurname,
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
            :disabled="hasAuth"
          >
          </a-input>
        </a-form-item>
        <a-form-item label="中文名">
          <a-input
            size="large"
            placeholder="请输入名"
            v-decorator="[
              'name',
              {
                initialValue: userInfo.chiName,
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
            :disabled="hasAuth"
          >
          </a-input>
        </a-form-item>
        <a-form-item label="身份证号">
          <a-input
            size="large"
            placeholder="请输入身份证号"
            v-decorator="[
              'identityCard',
              {
                initialValue: certNo,
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
            :disabled="!!certNo"
          >
          </a-input>
        </a-form-item>
        <a-form-item label="银行卡号">
          <a-input
            size="large"
            placeholder="请输入银行卡号"
            v-decorator="[
              'bankCardNo',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          >
          </a-input>
        </a-form-item>
        <mobile-input
          label="手机号码"
          :form="form"
          placeholder="请输入银行卡绑定手机号码"
          phoneKey="mobile"
          :validateHandler="handleFieldValidate"
          @change="onPhoneChange"
        ></mobile-input>
        <a-form-item label="验证码">
          <user-slider-captcha ref="verify" size="large" @change="onCaptchVerify">
          </user-slider-captcha>
        </a-form-item>
        <a-form-item label="手机验证码">
          <user-verification-code placeholder="请输入手机动态码" size="large" actionText="获取手机动态码" :areaCode="areaCode" :smsType="10" :value="phone" :token="token" handlerErrorBySelf @change="onVerificationCodeChange" @error="onVerificationCodeError">
          </user-verification-code>
        </a-form-item>
        <a-form-item :wrapper-col="wrapperColOffset">
          <div class="agreement">
            <a-checkbox style="line-height: 22px;" v-model="agreement">
              我已阅读，理解并同意
              <a v-for="item in agreements" :key="item.title" target="_blank" :href="item.url">{{ item.title }}</a>
            </a-checkbox>
            <br>
            <a-checkbox style="top: -16px;" v-if="ffpAutoRegisterSettingVisible" v-model="ffpAutoRegister">
              同时注册金鹏俱乐部会员
            </a-checkbox>
          </div>
          <a-button style="margin-right: 20px;" size="large" @click="onReset">重置</a-button>
          <a-button type="primary" size="large" :loading="loading" html-type="submit">银联认证</a-button>
        </a-form-item>
      </a-form>
      <div class="mod-tip">
        <h4>温馨提示</h4>
        <p>线上实名认证暂时仅支持使用中国大陆身份证信息及银行卡信息进行实名认证，不支持通过护照等其他类型证件办理实名。</p>
        <p>请您使用银行预留的手机号接收验证短信，如该手机号与您会员档案中的不一致，我们将为您更新您的会员档案。</p>
        <p>特殊情况下因您所处网络环境因素可能会有延迟，如实名认证未生效，请重新登录后查看。</p>
        <p>如需任何帮助，请致电{{ app.name }}24小时服务热线{{ app.hotline }}。</p>
        <p v-if="ffpTipContent" v-html="ffpTipContent"></p>
        <p v-if="cmsPageTips" v-html="cmsPageTips.warmPromptContent"></p>
      </div>
    </div>
    <div v-else class="mod-code" >
      <img v-show="qrCodeUrl" :src="qrCodeUrl" alt="">
    </div>
  </div>
</template>

<script>
import { find, get } from 'lodash'
import { validate } from '@/utils/validate'
import { authenticate, getWxPayQrCode, getCommonQrCode, fetchAuthStatus } from '@/api/member'
import { getCmsDataFormat } from '@/utils/util'
import eventBus from '../../../components/eventBus.js'
import fromApp from '@/utils/from'
import Observer from '@/utils/observer'

export default {
  props: {
    userInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    ffpUserInfo: Object,
    type: String,
    authType: String
  },
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 19
      },
      wrapperColOffset: {
        span: 24
      },
      form: this.$form.createForm(this),
      areaCode: '',
      phone: '',
      agreement: false,
      token: '',
      finalToken: '',
      code: '',
      loading: false,
      agreements: [],
      hasAuth: false,
      errCode: '',
      app: {},
      // 同步注册金鹏会员配置
      ffpTipContent: '',
      ffpConfirmContent: '',
      ffpAutoRegisterSettingVisible: false,
      ffpAutoRegister: true,
      qrCodeUrl: '',
      authStatusPolling: null,
      cmsPageTips: null
    }
  },
  computed: {
    certNo () {
      const { userCerts = [] } = this.userInfo

      if (userCerts && userCerts.length) {
        const cert = find(userCerts, { certType: 5 })

        if (cert) {
          return cert.certNo
        }
      }

      return ''
    }
  },
  async created () {
    const { userInfo, type, ffpUserInfo } = this

    if (userInfo.phone) {
      this.phone = userInfo.phone
    }

    this.hasAuth = userInfo.authStatus === 4

    let userAppConfig = {}

    if (window.__MICRO_ROOT__) {
      const data = await window.__MICRO_ROOT__.cms.getPageData()

      if (data) {
        userAppConfig = data.config
      }
    }

    eventBus.$on('get-token', (value) => {
      this.onGetFinalToken(value)
    })

    this.app = fromApp()

    this.agreements = userAppConfig.agreements
    // 同步注册金鹏会员相关参数
    this.ffpTipContent = userAppConfig.ffpTipContent || ''
    this.ffpConfirmContent = userAppConfig.ffpConfirmContent || ''

    if (userAppConfig.ffpAutoRegisterSettingVisible === true && type !== 'forgetPassword') {
      this.ffpAutoRegisterSettingVisible = true
    }

    if (userAppConfig.ffpAutoRegister === false) {
      this.ffpAutoRegister = false
    }

    // 已注册金鹏会员
    if (ffpUserInfo) {
      this.ffpAutoRegister = false
      this.ffpAutoRegisterSettingVisible = false
    }

    this.fetchQrCode()
    this.getCmsData()
  },
  beforeDestroy () {
    this.clearPolling()
  },

  methods: {
    async getCmsData () {
      const cmsData = await getCmsDataFormat()
      this.cmsPageTips = get(cmsData, 'tips') ?? null
    },
    handleFieldValidate (rule, value, callback) {
      validate('authenticate', this.form.getFieldsValue(), rule.fullField).then(({ valid, error }) => {
        if (valid) {
          callback()
        } else {
          callback(error)
        }
      })
    },
    onSubmit (e) {
      e.preventDefault()

      this.form.validateFields((errors, values) => {
        if (!errors) {
          const { token, finalToken, code, agreement, type, ffpAutoRegisterSettingVisible, ffpConfirmContent, ffpAutoRegister } = this
          if (!code) {
            this.$error({
              content: '请输入手机动态码！',
              centered: true
            })
            return
          }

          if (!token) {
            this.$error({
              content: '请拖动滑块完成验证！',
              centered: true
            })
            return
          }

          if (!finalToken) {
            this.$error({
              content: '请点击获取动态码！',
              centered: true
            })
            return
          }

          if (!agreement) {
            this.$error({
              content: '请阅读，理解并同意相关协议！',
              centered: true
            })
            return
          }

          const params = {
            pan: values.bankCardNo,
            phoneNO: values.mobile,
            areaCode: values.areaCode,
            lastNameZh: values.surname,
            firstNameZh: values.name,
            idType: 0,
            cardHolderId: values.identityCard,
            sliderCaptCha: finalToken,
            smsCode: code,
            event: 0
          }

          if (type === 'auth') {
            params.event = ffpAutoRegister ? 2 : 1
          }

          const observer = new Observer()

          if (ffpAutoRegisterSettingVisible && ffpAutoRegister) {
            observer.add(() => {
              return new Promise((resolve, reject) => {
                this.$confirm({
                  title: '温馨提示',
                  content: ffpConfirmContent,
                  onOk: () => {
                    resolve()
                  },
                  onCancel: () => {
                    reject(new Error('cancel'))
                  },
                  okText: '继续认证',
                  cancelText: '取消认证'
                })
              })
            })
          }

          observer.complete = async () => {
            try {
              this.loading = true
              const data = await authenticate(params)

              this.$emit('next', data)
            } catch (err) {
              this.$refs.verify.refresh()
              this.$error({
                content: err.message,
                centered: true
              })

              this.loading = false
              if (err.code.toString().includes(1000)) {
                this.errCode = err.code
              }
            }
          }
          observer.start()
        }
      })
    },
    onReset () {
      const that = this

      this.$confirm({
        title: '温馨提示',
        content: '确定要重置表单？',
        onOk () {
          that.form.resetFields()
        },
        okText: '确定',
        cancelText: '取消'
      })
    },
    onPhoneChange ({ areaCode, phone }) {
      this.areaCode = areaCode
      this.phone = phone
    },
    onCaptchVerify (value) {
      this.token = value
      if (this.errCode.toString().includes(1000)) {
        this.finalToken = value
      }
    },
    onVerificationCodeChange (value) {
      this.code = value
    },
    onVerificationCodeError (err) {
      this.$error({
        content: err.message,
        centered: true
      })
    },
    onGetFinalToken (value) {
      this.finalToken = value
      this.errCode = ''
    },
    // 根据实名认证类型获取二维码数据
    async fetchQrCode () {
      const { authType } = this
      if (!['WX_PAY_AUTH', 'WX_FACE_AUTH'].includes(authType)) return
      try {
        let data = null
        switch (authType) {
          case 'WX_PAY_AUTH':
            data = await getWxPayQrCode()
            break
          case 'WX_FACE_AUTH':
            data = await getCommonQrCode({
              realNameType: 'wechatMiniFace',
              configCode: 'face'
            })
            break
          default:
            break
        }
        if (!data) return
        this.qrCodeUrl = `data:image/png;base64,${data}`

        // 轮询查询实名认证状态
        this.authStatusPolling = setInterval(() => {
          this.fetchAuthStatusByPolling()
        }, 6000)
      } catch (err) {
        this.$message.error(err.message)
      }
    },
    fetchAuthStatusByPolling () {
      fetchAuthStatus().then(() => {
        this.clearPolling()
        this.$emit('next')
      }).catch((error) => {
        // 特殊状态码需要重新登录
        if ([100010134, 100020007].includes(error.code)) {
          this.$message.error('用户信息异常，请重新登录！')
          this.clearPolling()
          this.$router.replace('/login')
        }
      })
    },
    clearPolling () {
      if (this.authStatusPolling !== null) {
        clearInterval(this.authStatusPolling)
        this.authStatusPolling = null
      }
    }

  }
}
</script>
